"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacityHighest = exports.opacityHigh = exports.opacityNormal = exports.opacityLow = exports.opacityLowest = exports.baseOpacityHighest = exports.baseOpacityHigh = exports.baseOpacityNormal = exports.baseOpacityLow = exports.baseOpacityLowest = void 0;
exports.baseOpacityLowest = '0%';
exports.baseOpacityLow = '8%';
exports.baseOpacityNormal = '16%';
exports.baseOpacityHigh = '24%';
exports.baseOpacityHighest = '96%';
exports.opacityLowest = '0%';
exports.opacityLow = '8%';
exports.opacityNormal = '16%';
exports.opacityHigh = '24%';
exports.opacityHighest = '96%';